import useToastContext from "hooks/useToastContext";
import jwt_decode from "jwt-decode";
import { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPost, apiPut } from "../utils/apiFetch";
import apiPath from "../utils/pathObj";
const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  const { i18n } = useTranslation();
  let [user, setUser] = useState(() => (localStorage.getItem("token") ? jwt_decode(localStorage.getItem("token")) : null));
  const [hasNewNotification, setHasNewNotification] = useState(false);
  const [loginObj, setLoginObj] = useState({});
  const [language, setLanguage] = useState(localStorage.getItem("language") === "en" ? 1 : 2);
  const [sidebarStatus, setSidebarStatus] = useState(localStorage.getItem("sidebar"));
  const [pageName, setPageName] = useState(localStorage.getItem("pageName") ? localStorage.getItem("pageName") : "Dashboard");
  const navigate = useNavigate();
  const [lastActivity, setLastActivity] = useState(new Date());
  const notification = useToastContext();
  const [loginMessage, setLoginMessage] = useState("Admin details updated successfully.");
  const [loading, setLoading] = useState(false)


  useEffect(() => {
    if (loading) {
      document.getElementById("loader").classList.remove("hidden");
    } else {
      document.getElementById("loader").classList.add("hidden");
    }
  }, [loading])

  const updatePageName = (name) => {
    localStorage.setItem("pageName", name);
    setPageName(name);
  };

  let loginUser = async (body) => {
    setLoading(true)
    const { status, data } = await apiPost(apiPath.loginUser, body);
    if (status === 200) {
      if (data.success) {
        navigate("/login-otp", {
          state: {
            otpID: data?.results?.otpID,
            input: body?.input,
            password: body?.password,
          },
        });
      } else {
        notification.error(data.message);
      }
    }
    setLoading(false)
  };

  const updateProfile = async (formData) => {
    try {
      const res = await apiPut(apiPath.editProfile, formData);
      const token = res?.data?.results?.token || null;
      const refresh_token = res?.data?.results?.refresh_token || null;
      localStorage.setItem("token", token);
      setLoginMessage(res?.data?.message);
      notification.success(res?.data?.message);
      localStorage.setItem("refresh_token", refresh_token);
      setUser(jwt_decode(token));
    } catch (err) {
      console.log("err:", err);
    }
  };

  const getCompleteProfile = async () => {
    try {
      const res = await apiGet(apiPath.getCompleteProfile);
      if (res.data.success) {
        setUser((prevValue) =>
          prevValue
            ? {
                ...prevValue,
                notifications: res.data.results.notifications,
                wallet_amount: res.data.results.wallet_amount
              }
            : res.data.results
        );
        setHasNewNotification(res.data.results.hasNewNotification);
      }
    } catch (err) {}
  };

  const handleSidebar = () => {
    let s1 = localStorage.getItem("sidebar");
    localStorage.setItem("sidebar", s1 === "open" ? "close" : "open");
    setSidebarStatus(s1 === "open" ? "close" : "open");
  };

  let logoutUser = () => {
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    document.body.classList.add("body-img");
    navigate("/login");
  };

  useEffect(() => {
    if (localStorage.getItem("language") === "en") {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("al");
    }
    if (user) {
      getCompleteProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let contextData = {
    user,
    loginUser: loginUser,
    logoutUser: logoutUser,
    updateProfile: updateProfile,
    sidebarStatus: sidebarStatus,
    handleSidebar,
    pageName,
    updatePageName,
    setLoginObj,
    loginObj,
    loginMessage,
    language,
    setLanguage,
    setUser,
    setLastActivity,
    lastActivity,
    hasNewNotification,
    setHasNewNotification,
    getCompleteProfile,
    setLoading
  };
  return <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>;
};
